import { Button, Drawer, Hairline, Input, Label, Select } from "@components";
import styles from "@styles/pages/flow/Flow.module.scss";
import { FlowAPI } from "providers/FlowAPI";
import { useEffect, useState } from "react";
import { SuccessIcon } from "shared/components/Icons";

export const FlowUpdateDrawer = ({ visible, flow, onClose, folders }) => {
  const [name, setName] = useState(flow?.name);
  const [rank_bypass, setRankByPass] = useState(flow?.type == "RANK_BYPASS");
  const [folder, setFolder] = useState(flow?.folder);
  const [loading, setLoading] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  useEffect(() => {
    if (visible) {
      setShowSuccess(false);
      setName(flow?.name);
      setRankByPass(flow?.type == "RANK_BYPASS");
      setFolder(flow?.folder);
    }
  }, [visible]);

  const selectFolder = (folder) => {
    setFolder(folder == -1 ? null : folder);
  };

  const folderOptions = (folders || []).map((folder) => ({
    label: folder.name,
    value: folder.id,
  }));

  const onSave = async () => {
    setLoading(true);
    const saveNameResponse = await FlowAPI.putFlow(flow.id, {
      name: name,
      folder: folder,
      rank_bypass: true,
    });

    if (saveNameResponse.getErrors([]).length > 0) {
      alert({
        text: saveNameResponse.getErrors(["Ocorreu um erro ao salvar"])[0],
        buttonText: "Voltar",
      });
      return;
    } else setShowSuccess(true);

    setLoading(false);
  };

  return (
    <Drawer
      visible={visible}
      title="Editar"
      onClose={onClose}
      footer={
        showSuccess ? (
          <Button
            design="primary"
            className="w-100"
            text="Fechar"
            disabled={!name || loading}
            loading={loading}
            onClick={onClose}
          />
        ) : (
          <Button
            design="primary"
            className="w-100"
            text="Salvar"
            disabled={!name || loading}
            loading={loading}
            onClick={() => onSave()}
          />
        )
      }
    >
      {!showSuccess && (
        <>
          <Input
            value={name}
            label={"Fluxo"}
            onChange={async (text) => setName(text.target.value)}
            design="two"
          />
          {/* <Checkbox
              family="rank_bypass"
              className="mt-15"
              value={true}
              checked={rank_bypass}
              onChange={() => setRankByPass(!rank_bypass)}
            >
              Priorização máxima
            </Checkbox> */}

          <Hairline className="mt-20 mb-20" />
          <Label text={"Deseja agrupar este fluxo em uma pasta?"} />
          <Select
            label="Pasta"
            className="w-100"
            value={folder}
            options={[{ label: "Selecione", value: -1 }].concat(folderOptions)}
            onChange={(e) => selectFolder(e.target.value)}
          />
        </>
      )}

      {showSuccess && (
        <div className={styles.success}>
          <div className={styles.successIcon}>
            <SuccessIcon />
          </div>
          <p>As alterações foram aplicadas.</p>
        </div>
      )}
    </Drawer>
  );
};
